import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../ui/Logo';
import { ArrowRight } from 'lucide-react';
export function TitleSlide() {
  return <div className="w-full h-full bg-bg-dark text-white flex flex-col items-center justify-center relative overflow-hidden" data-id="element-315" data-mp="l55fuo7q2zkb">
      {/* Animated Background Network */}
      <div className="absolute inset-0 overflow-hidden opacity-20" data-id="element-316" data-mp="c9z8vlwpubg7">
        {[...Array(5)].map((_, i) => <motion.div key={i} className="absolute border border-accent/30 rounded-full" style={{
        width: 300 + i * 100,
        height: 300 + i * 100,
        left: '50%',
        top: '50%',
        x: '-50%',
        y: '-50%'
      }} animate={{
        scale: [1, 1.1, 1],
        rotate: [0, 90, 180],
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 20 + i * 5,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-317" data-mp="7d8s0wd37btq" data-mpi={i} />)}
      </div>

      <div className="relative z-10 text-center max-w-4xl px-6" data-id="element-318" data-mp="10q28mhviblyp">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-319" data-mp="10o8yutplklmh">
          <Logo variant="light" size="xl" className="justify-center mb-6" data-id="element-320" data-mp="1ej1owm345k7b" />
        </motion.div>

        <motion.h2 className="text-2xl md:text-4xl font-light text-accent mb-8 tracking-wide" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} data-id="element-321" data-mp="1jfibhbunzqia">
          Unser Weg zu Ihrer Software
        </motion.h2>

        <motion.p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} data-id="element-322" data-mp="228m6b0jmc9eh">
          Von der ersten Prozessanalyse bis zum langfristigen Support – so
          entwickeln wir Schritt für Schritt gemeinsam mit Ihnen.
        </motion.p>
      </div>

      <motion.div className="absolute bottom-12 flex items-center text-accent/80 text-sm font-medium tracking-widest uppercase" initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 5, 0]
    }} transition={{
      delay: 1.5,
      duration: 2,
      repeat: Infinity
    }} data-id="element-323" data-mp="1t608xvzn5cc0">
        Weiter <ArrowRight className="ml-2 w-4 h-4" data-id="element-324" data-mp="1acmnchhtii92" />
      </motion.div>
    </div>;
}